<div class="controls" [class.controls-floating-mode]="floating">
  <div class="controls-left hide-on-md">
    @if (showLeft) {
      <button type="button" class="btn pin-btn" [class.pinned]="settings.floatingControls()"
        title="Toggle floating action bar" (click)="settings.toggleFloatingControls()">
        <span class="icon icon-pushpin"></span>
      </button>
      <div class="import-dropdown-container" appDelayedMouseleave (appDelayedMouseleave)="showImportOptions = false">
        <button type="button" class="btn export-import-button" (click)="quickImport()">
          Import
        </button>
        <button class="btn export-import-button import-dropdown" (click)="showImportOptions = !showImportOptions">⌄</button>
        @if (showImportOptions) {
          <button type="button" class="btn export-import-button import-with-options-btn" (click)="importWithOptions()">
            <span class="icon icon-cog import-menu-icon" aria-hidden="true"></span>
            <span>Custom Import</span>
          </button>
          @if (isDevMode) {
            <button type="button" class="btn export-import-button import-with-options-btn import-clipboard-btn" (click)="importFromClipboard()">
              <span class="icon icon-clipboard import-menu-icon" aria-hidden="true"></span>
              <span>Import from Clipboard</span>
            </button>
          }
        }
      </div>
    }
  </div>
  <div class="controls-center">
    @if (showCenter) {
      <div class="save-dropdown-container" (mouseleave)="showSaveOptions = false">
        <button type="button" class="btn download-btn" (click)="save()">
          {{ saveButtonText() }}
          @if (!supportsFileSystemAccess) {
            <span class="icon icon-info button-icon" title="File System API is not supported or enabled in this browser. Using Brave or another Chromium-based browser? Enable the setting at brave://flags/#file-system-access-api"></span>
          }
        </button>
        @if (hasLinkedHandle()) {
          <button class="btn download-btn save-dropdown" (click)="showSaveOptions = !showSaveOptions">⌄</button>
          @if (showSaveOptions) {
            <button type="button" class="btn download-btn save-new-file-btn" (click)="saveToNewFile(); showSaveOptions = false">
              Save to new file
            </button>
          }
        }
      </div>

      @if (!isBeta && !isLegacy) {
        <button type="button" class="btn" [class.copy-btn]="!userName()" [class.sync-btn]="userName()" (click)="syncOrLogin()" [disabled]="synchronizing || syncDisabled || (userName() && disableSyncUntilRealmDown)">
          {{ syncCountdown || (userName() ? syncText : 'Log in to Sync') }}
          @if (syncWarning) {
            <span class="icon icon-warning" title="{{ syncWarning }}"></span>
          } @else if (userName() && syncWarningUntilRealmDown) {
            <app-tooltip-wrapper style="display: inline-block; margin-left: 4px;">
              <span class="icon icon-warning"></span>
              <ng-template #tooltip>
                You can Sync the filter to your account, but it will <strong>no longer load in the current version of the game</strong>. Also, we cannot guarantee 100% that it contains no errors. Once the servers go down and the realm is patched, we'll verify that the filter is working correctly, and remove this warning. To be sure, we advise you to check back here and re-Sync just before launch.
              </ng-template>
            </app-tooltip-wrapper>
          } @else if (userName() && disableSyncUntilRealmDown) {
            <span class="icon icon-warning" title="Sync is disabled until the realm is down and the servers are patched."></span>
          }
        </button>
      }

      <button type="button" class="btn copy-btn" (click)="copyToClipboard()">
        {{ copyText }}
      </button>
    }
  </div>
  <div class="controls-right">
    @if (showRight) {
      <button type="button" class="btn pin-btn show-on-md" [class.pinned]="settings.floatingControls()"
        title="Toggle floating action bar" (click)="settings.toggleFloatingControls()">
        <span class="icon icon-pushpin"></span>
      </button>
      <div class="import-dropdown-container show-on-md" appDelayedMouseleave (appDelayedMouseleave)="showImportOptions = false">
        <button type="button" class="btn export-import-button" (click)="quickImport()">
          Import
        </button>
        <button class="btn export-import-button import-dropdown" (click)="showImportOptions = !showImportOptions">⌄</button>
        @if (showImportOptions) {
          <button type="button" class="btn export-import-button import-with-options-btn" (click)="importWithOptions()">
            <span class="icon icon-cog import-menu-icon" aria-hidden="true"></span>
            <span>Custom Import</span>
          </button>
          @if (isDevMode) {
            <button type="button" class="btn export-import-button import-with-options-btn import-clipboard-btn" (click)="importFromClipboard()">
              <span class="icon icon-clipboard import-menu-icon" aria-hidden="true"></span>
              <span>Import from Clipboard</span>
            </button>
          }
        }
      </div>
      @if (tab === 'quick-filters') {
        <button type="button" class="btn clear-btn" [class.download-btn]="initialVisit" style="margin-left: 5px" (click)="onPresetsClick()">
          Presets
        </button>
      }
      <button type="button" class="btn clear-btn" style="margin-left: 5px;" (click)="clear()">
        Reset
      </button>
      <!-- <button type="button" class="btn toggle-search-btn">
        <span alt="Toggle" class="chevron"></span>
        Hide Filters
      </button> -->
    }
  </div>
  <div class="clear"></div>
</div>

